import { ModuleTypes } from '$const';
import DraggableModuleContainer from '~components/generic/module/DraggableModuleContainer';
import { ModulesListPopover } from '~components/generic/module/ModulesListPopover/ModulesListPopover';
import { IEntityComponentProps } from '~interfaces/props';
import { UiComponentCssProvider } from '~modules/ui-component-css/UiComponentCssContext';
import { getRelatedEntityIds } from '~services/entity-helpers';
import { PageLayout } from './PageLayout';
import PageLock from './PageLock';

export default function Page({ data, editing, stable }: IEntityComponentProps) {
  // show empty page if no data are available
  const childModuleIds = data ? getRelatedEntityIds(data, 'field_modules') : [];
  const childModuleIdsLength = childModuleIds.length - 1;

  return (
    <PageLayout className="page--cms">
      <PageLock />
      <UiComponentCssProvider>
        {childModuleIds.map((id, i) => (
          <DraggableModuleContainer
            parentIsStable={stable}
            index={i}
            key={`${id}_${i}`}
            entityId={id}
            parentContext={data.id}
            parentType={data.type}
            fieldName="relationships.field_modules.data"
            siblingsLength={childModuleIdsLength}
            canMove={editing}
          />
        ))}
        {childModuleIdsLength === -1 &&
          (editing ? (
            <div className="container relative">
              <ModulesListPopover type={ModuleTypes.nodePage} parentContext={data.id} index={0} />
            </div>
          ) : (
            <div className="o-text--center u-margin-top-xl o-text--quiet">
              <div className="u-size-xl">
                <i className="c-icon-custom c-icon-custom--modules-2" />
              </div>
              <span>Edit this page to add content to this page!</span>
            </div>
          ))}
      </UiComponentCssProvider>
    </PageLayout>
  );
}
